import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    welcome: 'Welcome',
    servicesTitle: {
      title1: 'We create',
      title2: 'modern experiences',
      description: "We design and build digital products that feel fresh, intuitive, and seamless. Whether it's a showcase website, a web or mobile app, or dynamic visual content — we turn ideas into polished, high-performing experiences."
    },
    weMakeTitle: 'we make it easy',
    heroSection: {
      title: 'We bring your digital vision to life',
      description: 'From your brand identity to your website, app, or custom platform — we take care of everything. Strategy, design, development — one team, one flow, zero headaches.',
      button: "Let's Talk"
    },
    feedbackTitle: 'Feedback',
    faq: {
      title: "Got Questions ?\nwe've got answers",
      q1: 'What services does Webeasy offer?',
      a1: 'We design and develop websites, e-commerce stores, mobile apps, and custom web platforms. We also provide branding, UX/UI design, and ongoing maintenance.',
      q2: 'How much does a project cost?',
      a2: 'Our pricing depends on the project scope. Landing pages start at €990, while custom platforms are priced after a detailed consultation. Get in touch for a free quote.',
      q3: 'How long does it take to build a website?',
      a3: 'On average, a standard website takes 2 to 4 weeks. More complex platforms or apps may take longer, depending on features and integrations.',
      q4: 'Will I be able to update the website myself?',
      a4: 'Yes. We use CMS or custom admin panels that let you easily manage your content without any technical knowledge.',
      q5: 'Do you work with international clients?',
      a5: 'Yes. We work remotely with clients worldwide and adapt our workflows to your timezone and language.'
    },
    legalNotice: {
      title: 'Legal Notice',
      publisher: 'Publisher',
      publisherText1: 'The website webeasy.pro is operated and published by:',
      publisherText2: 'Limited Liability Company registered in the State of New Mexico, USA',
      publisherText3: 'EIN (Employer Identification Number): 33-4137679',
      registeredAddress: 'Registered Address:',
      address: '1209 Mountain Road Pl NE, Suite N\nAlbuquerque, NM 87110, United States',
      hosting: 'Hosting',
      hostingText1: 'The website is hosted by:',
      hostingText2: '2 rue Kellermann, 59100 Roubaix, France',
      hostingText3: 'Website: https://www.ovhcloud.com',
      hostingText4: 'Phone: +33 9 72 10 10 07',
      liability: 'Liability',
      liabilityText1: 'WEBEASY LLC makes every effort to provide accurate and up-to-date information on its website. However, the company cannot be held responsible for any errors, omissions, or delays in updating the content.',
      liabilityText2: 'Access to the site may be interrupted at any time without prior notice for maintenance or technical reasons.',
      intellectualProperty: 'Intellectual Property',
      intellectualPropertyText: 'All content on this website (texts, images, graphics, logos, etc.) is the exclusive property of WEBEASY LLC unless stated otherwise. Any unauthorized reproduction or use of any content is strictly prohibited and may result in legal action.',
      personalData: 'Personal Data',
      personalDataText1: "WEBEASY LLC is committed to protecting the privacy of users' personal data, in compliance with applicable laws, including the General Data Protection Regulation (GDPR) for European users.",
      personalDataText2: 'To request access, correction, or deletion of your personal data, please contact: privacy@webeasy.pro'
    },
    worksDetail: {
      title: 'Project Details',
      text: 'Discover the details of our creative and innovative projects.',
      button: 'Back to Works'
    },
    notFound: {
      text: "Oops! The page you're looking for does not exist.",
      button: "Back to Home"
    },
    footer: {
      title: "Let's talk about your project",
      description: "The full cycle of services to create and launch a website from scratch or redesign a live website along with the modern trends and requirements."
    },
    servicesSection: {
      brandingTitle: 'Branding and Identity',
      brandingText: 'We craft unique brand identities that speak your values and connect with your audience — from logos and brand guidelines to complete visual systems.',
      websiteTitle: 'Website Design and development',
      websiteText: 'We design and develop sleek, responsive websites tailored to your goals — combining elegant UI/UX with cutting-edge performance and SEO best practices.',
      mobileTitle: 'Mobile App development',
      mobileText: 'We build fast, intuitive, and scalable mobile apps — from MVPs to full-featured applications — with a strong focus on user experience and efficiency.',
      ecommerceTitle: 'E-commerce',
      ecommerceText: 'From product pages to checkout, we create seamless e-commerce platforms that drive conversions — with custom features, secure payments, and easy management.',
      button: 'Go for it !'
    },
    workCards: {
      title: 'What can we do for you ?',
      description: 'Webeasy supports you at every digital stage — from branding and UI/UX design to website and web app development. Whether you need a logo, a full design system, or a custom platform, we’ve got you covered.',
      button: 'Take a look'
    },
    navbar: {
      home: 'Home',
      works: 'Works',
      services: 'Services',
      pricing: 'Pricing',
      talk: "Let's Talk"
    },
    pricing: {
      title: 'Webeasy Offers – Premium & Custom Websites',
      text: 'We don’t joke around with quality, which is why we decided to offer you packs tailored to your needs.',
      options: 'Available options:',
      bestSeller: 'Best Seller',
      backpack: {
        title: 'Backpack',
        service: 'One page Premium',
        priceText: 'From',
        price: '990€',
        features: [
          '100% custom design',
          '1 complete landing page (5 to 7 sections)',
          'Mobile responsive & optimized UX',
          'Animations',
          'Custom domain connection',
          'Integrated contact form',
          'SEO optimized'
        ],
        options: [
          'Professional logo and brand guidelines: +€500',
          'Extra section(s): +€50/section',
          'Optimized content writing: +€100',
          'Multilingual: +€200/language',
          'Maintenance & hosting: +€20/month'
        ]
      },
      twopack: {
        title: '2Pack',
        service: 'Showcase Website + Branding',
        priceText: 'From',
        price: '1890€',
        features: [
          'Fully custom website (6 to 10 pages)',
          'Professional logo included',
          'Professional brand guidelines',
          'Mobile responsive & optimized UX',
          'Animations',
          'Custom domain connection',
          'Integrated contact form',
          'SEO optimized'
        ],
        options: [
          'Extra pages: +€90/page',
          'Social Media Pack (visuals): +€150',
          'SEO optimization + copywriting: +€300',
          'Annual maintenance & hosting: +€30/month',
        ]
      },
      sixpack: {
        title: 'Sixpack',
        service: 'E-commerce Website',
        priceText: 'From',
        price: '2390€',
        features: [
          'WooCommerce shop',
          'Up to 10 products configured',
          'Payment setup',
          'Premium design',
          'Mobile responsive & optimized UX',
          'Google Sheets automation',
          'Custom domain connection',
        ],
        options: [
          'Extra products: +€20/product',
          'Click & Collect / Advanced shipping: +€200',
          'Professional logo and brand guidelines: +€400',
          'WooCommerce maintenance & hosting: +€50/month'
        ]
      },
      jetpack: {
        title: 'Jetpack',
        service: 'Custom web or app project',
        priceText: 'From',
        price: 'On quote',
        features: [
          'Strategic framing',
          'Professional UI/UX design',
          'Custom development (React, Node, API...)',
          'Backoffice, database & deployment',
          'Android/iOS mobile app',
          'Responsive web app',
          'Third-party API integration',
          'AI or GPT integration',
          'Full support',
        ]
      },
      chooseOffer: 'Choose this offer',
      onePage: 'One page website',
      ecommerce: 'E-commerce',
      custom: 'Custom development'
    },
    worksPage: {
      title: 'Our Works, Your Vision',
      text: 'We work and collaborate with global clients to establish and create digital products that align with business objectives and user needs.',
      buttonText: 'Start a project'
    },
    contactForm: {
      title: 'Contact Us',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email',
      subjectPlaceholder: 'Subject',
      servicesLabel: 'Desired services',
      onePage: 'One page website',
      ecommerce: 'E-commerce',
      custom: 'Custom development',
      showcase: 'Showcase Website',
      mobile: 'Mobile App',
      branding: 'Branding',
      motion: 'Motion Design',
      other: 'Other',
      budgetPlaceholder: 'Your budget',
      budget1: '$0 - $1,000',
      budget2: '$1,000 - $5,000',
      budget3: '$5,000 - $15,000',
      budget4: '$15,000 - $30,000',
      budget5: '+ $30,000',
      messagePlaceholder: 'Your message',
      phonePlaceholder: 'Your phone number',
      countryPlaceholder: 'Your country',
      send: 'Send',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Error while sending. Please try again.',
      errorNameRequired: 'Name is required',
      errorNameLength: 'Name must be at least 2 characters',
      errorEmailRequired: 'Email is required',
      errorEmailFormat: 'Invalid email format',
      errorSubjectRequired: 'Subject is required',
      errorSubjectLength: 'Subject must be at least 3 characters',
      errorServicesRequired: 'Please select at least one service',
      errorBudgetRequired: 'Budget is required',
      errorMessageRequired: 'Message is required',
      errorMessageLength: 'Message must be at least 10 characters',
      errorPhoneRequired: 'Phone number is required',
      errorCountryRequired: 'Country is required'
    },
  },
  fr: {
    welcome: 'Bienvenue',
    servicesTitle: {
      title1: 'Nous créons',
      title2: 'des expériences modernes',
      description: "Nous concevons et développons des produits digitaux frais, intuitifs et fluides. Site vitrine, application web ou mobile, contenu visuel dynamique — nous transformons vos idées en expériences performantes et soignées."
    },
    weMakeTitle: 'we make it easy',
    heroSection: {
      title: 'Nous donnons vie à votre vision digitale',
      description: "De votre identité de marque à votre site, application ou plateforme sur-mesure — on s’occupe de tout. Stratégie, design, développement — une équipe, un flux, zéro prise de tête.",
      button: "Discutons ensemble"
    },
    feedbackTitle: 'Avis',
    faq: {
      title: "Des questions ?\nOn a les réponses",
      q1: 'Quels services propose Webeasy ?',
      a1: "Nous concevons et développons des sites web, boutiques e-commerce, applications mobiles et plateformes sur-mesure. Nous proposons aussi du branding, du design UX/UI et de la maintenance.",
      q2: 'Combien coûte un projet ?',
      a2: "Nos tarifs dépendent du périmètre. Les landing pages démarrent à 990€, les plateformes sur-mesure sont estimées après un brief. Contactez-nous pour un devis gratuit.",
      q3: 'Combien de temps pour créer un site ?',
      a3: "En moyenne, un site standard prend 2 à 4 semaines. Les plateformes ou apps complexes peuvent demander plus de temps selon les fonctionnalités.",
      q4: 'Pourrai-je mettre à jour le site moi-même ?',
      a4: "Oui. Nous utilisons des CMS ou des panneaux d’administration sur-mesure pour que vous puissiez gérer votre contenu facilement, sans technique.",
      q5: 'Travaillez-vous avec des clients internationaux ?',
      a5: "Oui. Nous collaborons à distance avec des clients partout dans le monde et adaptons nos process à votre fuseau horaire et langue."
    },
    legalNotice: {
      title: 'Mentions légales',
      publisher: 'Éditeur',
      publisherText1: 'Le site webeasy.pro est édité et exploité par :',
      publisherText2: "Société à responsabilité limitée enregistrée dans l'État du Nouveau-Mexique, USA", 
      publisherText3: 'EIN (numéro d’identification employeur) : 33-4137679',
      registeredAddress: 'Adresse enregistrée :',
      address: '1209 Mountain Road Pl NE, Suite N\nAlbuquerque, NM 87110, États-Unis',
      hosting: 'Hébergement',
      hostingText1: 'Le site est hébergé par :',
      hostingText2: '2 rue Kellermann, 59100 Roubaix, France',
      hostingText3: 'Site web : https://www.ovhcloud.com',
      hostingText4: 'Téléphone : +33 9 72 10 10 07',
      liability: 'Responsabilité',
      liabilityText1: "WEBEASY LLC met tout en œuvre pour fournir des informations exactes et à jour sur son site. Cependant, la société ne peut être tenue responsable des erreurs, omissions ou retards de mise à jour.",
      liabilityText2: "L'accès au site peut être interrompu à tout moment sans préavis pour maintenance ou raisons techniques.",
      intellectualProperty: 'Propriété intellectuelle',
      intellectualPropertyText: "Tous les contenus de ce site (textes, images, graphismes, logos, etc.) sont la propriété exclusive de WEBEASY LLC sauf mention contraire. Toute reproduction ou utilisation non autorisée est strictement interdite et peut entraîner des poursuites.",
      personalData: 'Données personnelles',
      personalDataText1: "WEBEASY LLC s’engage à protéger la vie privée des utilisateurs, conformément aux lois en vigueur, dont le RGPD pour les utilisateurs européens.",
      personalDataText2: "Pour toute demande d’accès, de correction ou de suppression de vos données personnelles, contactez : privacy@webeasy.pro"
    },
    worksDetail: {
      title: 'Détails du projet',
      text: 'Découvrez les détails de nos projets créatifs et innovants.',
      button: 'Retour aux projets'
    },
    notFound: {
      text: "Oups ! La page que vous cherchez n'existe pas.",
      button: "Retour à l'accueil"
    },
    footer: {
      title: "Discutons de votre projet",
      description: "Tous les services pour créer et lancer votre site web, ou le refondre selon les tendances et exigences actuelles."
    },
    servicesSection: {
      brandingTitle: 'Branding et identité',
      brandingText: "Nous créons des identités de marque uniques qui reflètent vos valeurs et engagent votre audience — du logo à la charte graphique complète.",
      websiteTitle: 'Design et développement web',
      websiteText: "Nous concevons et développons des sites élégants et responsives, adaptés à vos objectifs — alliant UI/UX moderne, performance et SEO.",
      mobileTitle: 'Développement d’app mobile',
      mobileText: "Nous réalisons des applications mobiles rapides, intuitives et évolutives — du MVP à l’app complète — avec un focus sur l’expérience utilisateur.",
      ecommerceTitle: 'E-commerce',
      ecommerceText: "De la fiche produit au paiement, nous créons des plateformes e-commerce fluides et performantes — fonctionnalités sur-mesure, paiements sécurisés, gestion simplifiée.",
      button: "C'est parti !"
    },
    workCards: {
      title: 'Que peut-on faire pour vous ?',
      description: 'Webeasy vous accompagne à chaque étape digitale — du branding et design UI/UX au développement de sites et applications web. Besoin d’un logo, d’un design system complet ou d’une plateforme sur-mesure ? On s’occupe de tout.',
      button: 'Voir nos projets'
    },
    navbar: {
      home: 'Accueil',
      works: 'Projets',
      services: 'Services',
      pricing: 'Tarifs',
      talk: 'Discutons ensemble'
    },
    pricing: {
      title: 'Offres Webeasy - Sites Premium & sur-mesure',
      text: 'On ne rigole pas avec la qualité, c\'est pourquoi on a décidé de vous proposer des packs adaptés à vos besoins.',
      options: 'Options disponibles :',
      bestSeller: 'Best Seller',
      backpack: {
        title: 'Backpack',
        service: 'One page Premium',
        priceText: 'À partir de',
        price: '990€',
        features: [
          'Design 100% personnalisé',
          '1 landing page complète (5 à 7 sections)',
          'Responsive mobile & UX optimisée',
          'Animations',
          'Connexion domaine personnalisé',
          'Formulaire de contact intégré',
          'Optimisé SEO'
        ],
        options: [
          'Logo professionnel et charte graphique : +500€',
          'Section(s) supplémentaire(s) : +50€/section',
          'Rédaction de contenu optimisé : +100€',
          'Multilingue : +200€/langue',
          'Maintenance & hébergement : +20€/mois'
        ]
      },
      twopack: {
        title: '2Pack',
        service: 'Site vitrine + Branding',
        priceText: 'À partir de',
        price: '1890€',
        features: [
          'Site complet 100% personnalisé (6 à 10 pages)',
          'Logo professionnel inclus',
          'Charte graphique professionnelle',
          'Responsive mobile & UX optimisée',
          'Animations',
          'Connexion domaine personnalisé',
          'Formulaire de contact intégré',
          'Optimisé SEO'
        ],
        options: [
          'Pages supplémentaires : +90€/page',
          'Pack Réseaux Sociaux (visuels) : +150€',
          'Optimisation avancée SEO + rédaction : +300€',
          'Maintenance & hébergement : +30€/mois',
        ]
      },
      sixpack: {
        title: 'Sixpack',
        service: 'Site e-commerce',
        priceText: 'À partir de',
        price: '2390€',
        features: [
          'Boutique WooCommerce',
          'Jusqu\'à 10 produits configurés',
          'Configuration paiement',
          'Design Premium',
          'Responsive mobile & UX optimisée',
          'Automatisation Google Sheets',
          'Connexion domaine personnalisé',
          'Optimisé SEO'
        ],
        options: [
          'Produits supplémentaires : +20€/produit',
          'Click & Collect / Livraison avancée : +200€',
          'Logo professionnel et Charte graphique : +400€',
          'Maintenance et Hébergement WooCommerce : +50€/mois'
        ]
      },
      jetpack: {
        title: 'Jetpack',
        service: 'Projet web ou app sur-mesure',
        priceText: 'À partir de',
        price: 'Sur devis',
        features: [
          'Cadrage stratégique',
          'UI/UX design professionnel',
          'Développement custom (React, Node, API...)',
          'Backoffice, base de données & déploiement',
          'Application mobile Android/iOS',
          'Application web responsive',
          'Intégration API tierces',
          'Intégration IA ou GPT',
          'Accompagnement complet',
        ]
      },
      chooseOffer: 'Choisir cette offre',
      onePage: 'Site one page',
      ecommerce: 'E-commerce',
      custom: 'Développement sur-mesure'
    },
    worksPage: {
      title: 'Nos réalisations, votre vision',
      text: 'Nous travaillons et collaborons avec des clients du monde entier pour créer des produits digitaux alignés avec vos objectifs et les besoins de vos utilisateurs.',
      buttonText: 'Commencer un projet'
    },
    contactForm: {
      title: 'Contactez-nous',
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'Votre email',
      subjectPlaceholder: 'Sujet',
      servicesLabel: 'Services souhaités',
      onePage: 'Site one page',
      ecommerce: 'E-commerce',
      custom: 'Développement sur-mesure',
      showcase: 'Site vitrine',
      mobile: 'Application mobile',
      branding: 'Branding',
      motion: 'Motion design',
      other: 'Autre',
      budgetPlaceholder: 'Votre budget',
      budget1: '0€ - 1 000€',
      budget2: '1 000€ - 5 000€',
      budget3: '5 000€ - 15 000€',
      budget4: '15 000€ - 30 000€',
      budget5: '+ 30 000€',
      messagePlaceholder: 'Votre message',
      phonePlaceholder: 'Votre numéro de téléphone',
      countryPlaceholder: 'Votre pays',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
      success: 'Message envoyé avec succès !',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
      errorNameRequired: 'Le nom est requis',
      errorNameLength: 'Le nom doit contenir au moins 2 caractères',
      errorEmailRequired: 'L\'email est requis',
      errorEmailFormat: 'Format d\'email invalide',
      errorSubjectRequired: 'Le sujet est requis',
      errorSubjectLength: 'Le sujet doit contenir au moins 3 caractères',
      errorServicesRequired: 'Veuillez sélectionner au moins un service',
      errorBudgetRequired: 'Le budget est requis',
      errorMessageRequired: 'Le message est requis',
      errorMessageLength: 'Le message doit contenir au moins 10 caractères',
      errorPhoneRequired: 'Le numéro de téléphone est requis',
      errorCountryRequired: 'Le pays est requis'
    },
    services: {
      title: 'Nos services',
      description: 'Découvrez l\'ensemble de nos services pour donner vie à vos projets digitaux.',
      onePage: 'Site one page',
      ecommerce: 'E-commerce',
      custom: 'Développement sur-mesure',
      branding: 'Branding',
      uiux: 'UI/UX Design',
      motion: 'Motion Design',
      web: 'Développement Web',
      mobile: 'Développement Mobile',
      seo: 'SEO & Marketing',
      maintenance: 'Maintenance & Support',
      contact: 'Contactez-nous pour un devis personnalisé.'
    }
  }
};

const getDefaultLocale = () => {
  const lang = navigator.language || navigator.userLanguage;
  if (lang.startsWith('fr')) return 'fr';
  return 'en';
};

const i18n = createI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'en',
  messages,
});

export default i18n;
